module.exports = __webpack_public_path__ + "static/media/pic5.f362758b.jpg";